import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { authRequest } from '../../../../../common/request/authRequest';
import { DrawerPanelTitle, modalPanelStyles } from '../../Drawers/DrawerPanelTitle';


export const LocationModal = ({
	locationId,
	onFinish
}: any) => {

	const { projectGroup } = useAuth();
	const [location, setLocation] = useState(null);  

	useEffect(() => {
			
		authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${locationId}`, {})
		.then((response) => {setLocation(response);	})		
		},[]);

	return (
		<Modal
			open={true}
			footer={null}
			onCancel={onFinish}
			width={'40%'}
			{...modalPanelStyles}
			title={
				<DrawerPanelTitle
					title="Info del Local"
					location={location}
				/>
			}
		>
			{null}
		</Modal>
	)
}
